/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC, useState, useEffect, Dispatch, SetStateAction } from "react";
import { IconButton } from "@mui/material";
import { useNotificationCheck } from "hooks/NotificationWorker";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { NotificationBarProps } from "components/Common/NotificationBar";

interface Props {
  onClick: () => void;
  setAlert: Dispatch<SetStateAction<NotificationBarProps | undefined>>;
}

export const NotificationIconButton: FC<Props> = ({ onClick, setAlert }) => {
  const newNotification = useNotificationCheck();
  const [unread, setUnread] = useState(false);

  useEffect(() => {
    setUnread((pre) => pre || !!newNotification);
    if (newNotification) {
      setAlert({ notification: newNotification });
    }
  }, [newNotification, setAlert]);

  const handleClick = () => {
    setUnread(false);
    onClick();
  };

  return (
    <IconButton size="large" onClick={handleClick} color="secondary">
      {unread ? (
        <NotificationsActiveIcon fontSize="inherit" color="error" />
      ) : (
        <NotificationsIcon fontSize="inherit" color="secondary" />
      )}
    </IconButton>
  );
};
